module.exports = __webpack_public_path__ + "logo.svg?ecc3ff40be942c2bc2f061a3d30ff470";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = 16
// module chunks = 0